import React from 'react'
import PropTypes from 'prop-types'
import { PaymentElement } from '@stripe/react-stripe-js'
import { SubmissionError } from 'redux-form'
import { SubmitButton } from 'lp-components'
import { useStripeActions } from 'utils'
import { createPaymentElementOptions } from 'utils/stripeOptions'

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onSubmit: PropTypes.func,
  submitting: PropTypes.bool,
}

function StripeGiftPaymentFormContent({
  handleSubmit,
  onError,
  onSubmit = null,
  submitting = false,
}) {
  const { isProcessing, createPaymentMethod } = useStripeActions()

  const handleFormSubmit = async () => {
    if (submitting || isProcessing) return

    try {
      const paymentMethodId = await createPaymentMethod()
      if (onSubmit) {
        return await onSubmit(paymentMethodId)
      }
    } catch (error) {
      onError(error.message)
      throw new SubmissionError({ _error: error.message })
    }
  }

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} noValidate>
      <div className="group-block">
        <div className="col-6">
          <label htmlFor="stripe-payment-element" className="form-label">
            Payment Information
            <span className="required-indicator">*</span>
          </label>
          <div id="stripe-payment-element">
            <PaymentElement options={createPaymentElementOptions()} />
          </div>
        </div>
      </div>
      <div className="button-group">
        <SubmitButton submitting={submitting || isProcessing}>
          {submitting || isProcessing
            ? 'Processing Payment...'
            : 'Confirm Purchase'}
        </SubmitButton>
      </div>
    </form>
  )
}

StripeGiftPaymentFormContent.propTypes = propTypes

export default StripeGiftPaymentFormContent
